import api from '../services/api';
import { createCartDiscount } from '../services/graphql';
import { $Q, $Qll } from '../utils/query-selector';
import { addNodeSpinner } from '../utils/spinner';

/* It renders the discount price */
const renderPrice = (parent, amount) => {
  const totalPrice = $Q('.cart-discount__success #total-discount', parent);

  if (!totalPrice) return;

  const floatAmount = parseFloat(amount);
  const roundedAmount = Math.round(floatAmount);
  totalPrice.innerText = `- ${roundedAmount} ${window.Shopify.currencySymbol}`;
};

/**
 * Set code in input applied
 * @param {Object} infoStorage : It is the info for discount code and amount
 */
const setCode = (code) => {
  $Qll('input[name="discount-applied"]').forEach((applied) => {
    const appliedInput = applied;
    appliedInput.value = code;
  });
};

/* It validates if there is session storage for discount */
const validateStorage = () => {
  const parents = $Qll('.cart-discount');
  const storage = JSON.parse(
    sessionStorage.getItem('vintega_discount_applied')
  );

  if (storage) {
    parents.forEach((parent) => {
      const parentRef = parent;
      parentRef.dataset.state = 'false';
      addSubmitSpinners('.cart-discount__apply');
      addSubmitSpinners('#total-discount');
      actionDiscount(storage.code);
    });
  } else {
    parents.forEach((parent) => {
      const parentRef = parent;
      parentRef.dataset.state = 'false';
    });
  }
};

/**
 * It creates a new session storage discount amount
 * @param {String} code : It is the code applied
 * @param {Number} amount : It is the discount amount
 */
const updateStorage = (code) => {
  const infoStorage = JSON.stringify({ code });
  sessionStorage.setItem('vintega_discount_applied', infoStorage);
};

/* It removes session storage discount */
const removeSessionStorage = () => {
  sessionStorage.removeItem('vintega_discount_applied');
};

/**
 * Add spinners to buttons
 * @param {String} query : Query for spinner
 */
const addSubmitSpinners = (query) => {
  $Qll(query).forEach((button) => {
    addNodeSpinner(button);
  });
};

/**
 * Remove spinners to buttons
 * @param {String} query : Query for spinner
 */
const removeSubmitSpinners = (query) => {
  $Qll(query).forEach((button) => {
    const buttonRef = button;
    buttonRef.innerText = button.dataset.id;
  });
};

/**
 * It handles success response
 * @param {String} code : Inserted code
 * @param {String} amount : Amount from response
 */
const handleSuccessResponse = (code, amount) => {
  $Qll('.cart-discount').forEach((discount) => {
    const discountRef = discount;
    discountRef.dataset.state = 'true';
    renderPrice(discountRef, amount);
    setCode(code);
  });

  updateStorage(code);
};

/**
 * It handles response when there is an error
 * @param {String} message : Error message
 */
const handleErrorResponse = (message) => {
  $Qll('.cart-discount').forEach((discount) => {
    const discountRef = discount;
    const discountError = $Q('.cart-discount__error', discount);
    discountRef.dataset.state = 'error';
    discountError.innerText = message.trim();
  });

  removeSessionStorage();
};

/* It handles remove button action */
const handleRemoveButton = () => {
  $Qll('.cart-discount__success-btn-2').forEach((button) => {
    const removeBtn = button;
    button.addEventListener('click', async () => {
      addNodeSpinner(removeBtn);

      const data = await api.removeDiscounts();

      if (data.success) {
        removeSessionStorage();
        removeBtn.closest('.cart-discount').dataset.state = 'false';
        removeBtn.innerHTML = button.dataset.id;
      }
    });
  });
};

/**
 * It handles cancel button action
 * @param {HTMLCollection} discountCarts : The discount carts
 */
const handleCancelButton = (discountCarts) => {
  const cancelBtns = $Qll('.cart-discount__success-btn-1');
  const discountRefs = discountCarts;

  cancelBtns.forEach((button) => {
    button.addEventListener('click', async () => {
      if (discountRefs[0]) discountRefs[0].dataset.state = 'false';
      if (discountRefs[1]) discountRefs[1].dataset.state = 'false';
    });
  });
};

/**
 * On submit discount
 * @param {EventListener} event - Event on submit discount
 * @returns UI render discount
 */
const submitDiscount = (event) => {
  event.preventDefault();
  const { target: form } = event;
  const input = $Q('#discount-code', form);
  const discountCode = input.value || ' ';

  // > Discount
  console.log('discount');
  dataLayer.push({
    event: 'discount',
    discount_code: discountCode,
  });

  addSubmitSpinners('.cart-discount__apply');
  addSubmitSpinners('#total-discount');

  actionDiscount(discountCode);
};

async function actionDiscount(discountCode) {
  const apply = await api.discounts(discountCode);

  if (apply.error) {
    handleErrorResponse(data.message);
    return;
  }

  const data = await createCartDiscount(discountCode);
  if (!data) return;

  removeSubmitSpinners('.cart-discount__apply');
  removeSubmitSpinners('#total-discount');

  if (data.error) {
    handleErrorResponse(data.message);
    return;
  }

  const infoDiscount = resultsDiscount(data);
  handleSuccessResponse(infoDiscount.code, infoDiscount.amount);
}

/**
 * Return line discount code
 * @param {Object} r - Checkout results
 * @param {String} code - Discount code
 * @returns {Object} { code, amount, applied } or Null
 */
const resultsDiscount = (discountInfo) => {
  if (!discountInfo) return;
  const { discountCodes, discountAllocations, lines } = discountInfo;
  let allocationsData = discountAllocations;

  const lineDiscounts = lines.nodes
    .map((curr) => {
      return curr.discountAllocations[0];
    })
    .filter((item) => item && item);

  allocationsData = [...allocationsData, ...lineDiscounts];

  const result = {
    amount: allocationsData.reduce(
      (a, c) => a + Number(c.discountedAmount.amount),
      0
    ),
    applied: discountCodes[0].applicable,
    code: discountCodes[0].code,
  };

  return result;
};

const handleDiscountChange = () => {
  const discountCodes = $Qll('#discount-code');

  if (!discountCodes) return;

  discountCodes.forEach((code) => {
    code.addEventListener('input', () => {
      const buttons = $Qll('.cart-discount__apply');

      if (code.value) {
        buttons.forEach((button) => {
          button.disabled = false;
        });
      } else {
        buttons.forEach((button) => {
          button.disabled = true;
        });
      }
    });
  });
};

window.addEventListener('load', () => {
  const forms = $Qll('#discount-validation');

  if (forms) {
    forms.forEach((form) => form.addEventListener('submit', submitDiscount));
    const discountCarts = $Qll('.cart-discount');
    validateStorage();
    handleCancelButton(discountCarts);
    handleRemoveButton();
    handleDiscountChange();
  }
});
